// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 524) return "app.2.0.1.bundle.css";
	// return url for filenames based on template
	return undefined;
};